/** Dati di contatto e identificativi istituzionali della scuola (fonte unica). */
export const schoolContact = {
	name: "Scuola dell'infanzia Santa Marta – Casa Betania",
	addressLine: "Via Paganico, 29, 00049 Velletri RM",
	addressShort: "Via Paganico, 29 – 00049 Velletri (RM)",
	phone: {
		display: "+39 06 962 00 55",
		href: "tel:+39069620055",
	},
	mobile: {
		display: "+39 338 764 9282",
		href: "tel:+393387649282",
	},
	email: "santamartavelletri@gmail.com",
	pec: "santamartavelletri@pec.it",
	codiceMeccanografico: "RM1A596005",
	codiceFiscale: "02510770585",
	partitaIva: "01067681005",
} as const;
